var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('div',{staticClass:"wrap",class:_vm.status.name},[_vm._v(_vm._s(_vm.status.display_name))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }